import { takeLeading } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { deleteUserPassengerSaga } from "./user-passenger/deleteUserPassengerSaga";
import { fetchUserPassengersSaga } from "./user-passenger/fetchUserPassengersSaga";
import { updateUserPassengerSaga } from "./user-passenger/updateUserPassengerSaga";
import { fetchCorpUserPassengersSaga } from "./user-passenger/fetchCorpUserPassengersSaga";

export function* watchUpdateUserPassenger() {
  yield takeLeading(actionTypes.UPDATE_USER_PASSENGER, updateUserPassengerSaga);
}

export function* watchDeletePassengerSaga() {
  yield takeLeading(actionTypes.DELETE_USER_PASSENGER, deleteUserPassengerSaga);
}

export function* watchFetchUserPassengers() {
  yield takeLeading(actionTypes.FETCH_USER_PASSENGERS, fetchUserPassengersSaga);
}

export function* watchFetchCorpUserPassengers() {
  yield takeLeading(
    actionTypes.FETCH_CORP_USER_PASSENGERS,
    fetchCorpUserPassengersSaga
  );
}

export const sagas = {
  watchUpdateUserPassenger,
  watchDeletePassengerSaga,
  watchFetchUserPassengers,
  watchFetchCorpUserPassengers,
};
